import { render, staticRenderFns } from "./AnagraficaQuickConnext.vue?vue&type=template&id=3c621e70&"
import script from "./AnagraficaQuickConnext.vue?vue&type=script&lang=js&"
export * from "./AnagraficaQuickConnext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports